// stocai_frontend/src/components/HomePage/components/Action/SaveGoals.jsx

import React, { useEffect, useState, useRef } from "react";
import fullPot from "../../../../assets/full_pot.png";
import ConfettiLayer from "../Celebration/ConfettiLayer";

const SaveGoals = ({ isOpen, onClose, onNextObjective, objectiveText = "Gain a senior leader's support who talks about your work in bigger meetings." }) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setShowConfetti(true);
      const timer = setTimeout(() => setShowConfetti(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#000000CC]">
      <div 
        ref={modalRef}
        className="w-[742px] h-[510px] bg-white rounded-[20px] overflow-visible flex flex-col relative"
      >
        {/* Confetti Effect - centered on modal */}
        {showConfetti && (
          <div className="absolute inset-0 flex items-start justify-center pointer-events-none z-[200]" style={{ top: '-57px' }}>
            <ConfettiLayer colors={['#259594', '#54B0AF', '#FFFFFF', '#FFD700', '#FF6B6B']} />
          </div>
        )}

        {/* Full Pot Image - positioned at top with higher z-index */}
        <img
          src={fullPot}
          alt="Full Pot"
          className="absolute w-[98px] h-[178px] object-contain z-[150]"
          style={{
            top: '-57px',
            left: '322px',
          }}
        />

        {/* Teal Header Section */}
        <div className="w-full h-[305.5px] bg-[#259594] rounded-t-[20px] flex flex-col items-center justify-center px-12 pt-24 relative z-10">
          <h2 className="text-[28px] leading-[1.35] font-medium text-white text-center mb-16">
            Congratulations!<br />
            Your objective is now complete.
          </h2>
        </div>

        {/* White Box with Objective Text - positioned at intersection */}
        <div 
          className="absolute w-[549px] h-[119px] bg-white rounded-[8px] border border-[#DBDBDB] flex items-center justify-center px-8 shadow-[0px_0px_24px_0px_rgba(0,0,0,0.25)] z-[100]"
          style={{
            top: '250px',
            left: '96.5px',
          }}
        >
          <p className="text-[21px] leading-[1.35] font-medium text-[#424242] text-center">
            {objectiveText}
          </p>
        </div>

        {/* White Bottom Section */}
        <div className="flex-1 bg-white rounded-b-[20px] flex items-center justify-center relative z-10 pt-16">
          <button
            type="button"
            onClick={onNextObjective}
            className="w-[194px] h-[46px] rounded-[6.2px] bg-black flex items-center justify-center px-[25px] py-[13px]"
          >
            <span className="text-[17.01px] leading-[1] font-medium text-white">
              Next Objective &gt;
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveGoals;
